module.exports = __webpack_public_path__ + "img/rule-title.e844643a.png";